enum BillableItemType {
	EXAM = 'EXAM', 
	MEDOC = 'MEDOC', 
	OPERATION = 'OPERATION', 
	SERVICE = 'SERVICE'
}

export default BillableItemType;